export default class RideType {}

RideType.Types = {
  AIRPORT_DROPOFF: 'AIRPORTDROPOFF',
  AIRPORT_PICKUP: 'AIRPORTPICKUP',
  POINT_TO_POINT: 'POINTTOPOINT',
  ERROR: 'ERROR'
}



// WEBPACK FOOTER //
// ./src/models/ride_type.js